import React from "react";
export default function Gallery() {
  return (
    <div className="container my-4">
      <h2>Gallery</h2>
      <p>Gallery section will be updated soon.</p>
    </div>
  );
}
